var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7596 13.3798C25.7596 15.0016 25.4501 16.5614 24.8683 17.9851C24.0636 17.428 23.0856 17.0937 22.0457 17.0937C20.882 17.0937 19.8049 17.5023 18.9507 18.1832C17.8118 19.0869 17.0937 20.4858 17.0937 22.0457C17.0937 22.9741 17.3537 23.8531 17.8118 24.5959C17.8613 24.6826 17.9232 24.7692 17.9975 24.8559C16.5738 25.4377 15.0139 25.7596 13.3798 25.7596C6.54615 25.7596 1 20.2134 1 13.3798C1 6.54615 6.54615 1 13.3798 1C20.2134 1 25.7596 6.54615 25.7596 13.3798Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1396 13.3829V11.6621C10.1396 9.53273 11.65 8.65375 13.4946 9.71842L14.9802 10.5726L16.4657 11.4269C18.3102 12.4915 18.3102 14.2371 16.4657 15.3017L14.9802 16.156L13.4946 17.0102C11.65 18.0748 10.1396 17.2082 10.1396 15.0665V13.3829Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9942 22.0496C26.9942 22.9781 26.7342 23.857 26.2761 24.5998C26.0162 25.0455 25.6819 25.4416 25.2981 25.7635C24.4316 26.5434 23.2926 27.0015 22.0423 27.0015C20.2348 27.0015 18.6626 26.0359 17.8084 24.5998C17.3503 23.857 17.0903 22.9781 17.0903 22.0496C17.0903 20.4897 17.8084 19.0908 18.9473 18.1871C19.8015 17.5062 20.8786 17.0977 22.0423 17.0977C24.7782 17.0977 26.9942 19.3136 26.9942 22.0496Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8883 22.0234H20.1992",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0439 20.2188V23.9203",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle_plus.0045d8c7fe7cdfc4b3aea47a59471c22.svg";
export { ForwardRef as ReactComponent };